type PathParams = { [key: string]: string | number }

export const replacePathParams = (pathname: string, pathParams: PathParams): string => {
  const newPathname = pathname
    .split("/")
    .filter((path) => path !== "")
    .map((path) => {
      if (path.startsWith(":")) {
        const value = pathParams[path.slice(1)]
        if (value) {
          return encodeURIComponent(value)
        }
      }
      return path
    })
    .map((path) => `/${path}`)
    .join("")

  if (process.env.NODE_ENV === "development") {
    if (newPathname.includes(":")) {
      console.warn(`置換されてないパラメータがあります。${newPathname}`)
    }
  }

  return newPathname
}

export const replacePathParamsOfURL = (url: URL, pathParams: PathParams) => {
  const newUrl = new URL(url)
  newUrl.pathname = replacePathParams(newUrl.pathname, pathParams)
  return newUrl
}
